module.exports = __webpack_public_path__ + "assets/img/u309.cc8b45bd.png";